export default {
  appLanguages(state) {
    return state.appLanguages;
  },
  chatOptions(state) {
    return state.chatOptions;
  },
  availableRoles(state) {
    return state.availableRoles;
  },
  countries(state) {
    return state.countries;
  },
  availableCountries(state) {
    return state.availableCountries;
  },
  timezones(state) {
    return state.timezones;
  },
  timeOptions(state) {
    return state.timeOptions;
  },
};
